import { imagesArch } from "./imagesArch.js";
import { imagesBat } from "./imagesBat.js";
import { imagesDev } from "./imagesDev.js";
import { imagesServices } from "./imagesServices.js";

export const fr = {
  home: "/",
  locale: "fr",
  localeNav: "/fr",
  archNav: "architecture",
  servicesNav: "services",
  batNav: "batiment",
  devNav: "developpement",
  archTitle: "Architecture",
  archTitle2: "Mes Projets d'Architecture",
  batTitle: "Bâtiment",
  batTitle2: "Mes Réalisations",
  batTitle3:
    "Les travaux réalisés dans une grande partie tout seul, soit suivi d'un apprentie",
  batTitle4:
    "Un vrai pro est capable de réaliser des ouvres d'art, équipé d'un sceau d'outils et de quelques outils électroportatifs.",
  servicesTitle: "Services",
  devTitle: "Développement web",
  devTitle2: "Développement d'applications pour usage personnel",
  devTitleNav: "Développement",
  comments: "Commentaires",
  iLike: "J'aime",
  comment: "Commenter",
  share: "Distribuer",
  discoverProject: "Découvrir le projet...",
  footer_p1: "Boogysh. Tous droits réservés.",
  footer_p2: "Mis à jour:",
  identity: "Identité",
  lastName: "Nom",
  firstName: "Prénom",
  birthDay: "Date de naissance",
  birthPlace: "Lieu de naissance",
  countryOfBirth: "Pays de naissance",
  country: "Moldavie",
  nationalities: "Nationalités",
  nationalities_val: "Moldave, Roumaine",
  ssNumber: "Numéro de S.S.",
  adress: "Addresse",
  tel: "Téléphone",
  email: "E-mail",
  civilStatus: "État civil",
  civilStatus_val: "Marié, deux Enfants.",
  studies: "Études et Diplômes",
  school: "Ecole - Collège, MERENI",
  highSchool:
    "Lycée Républicain Universitaire Scientifique, profil physique-mathématique",
  bac: "Diplôme de Baccalauréat",
  college:
    "Université Technique de Moldavie, Faculté de l'Urbanisme et de l'Architecture Spécialité: Ingénierie urbaine",
  master: "Master: L'ingénierie des Constructions Civiles",
  master_stopped:
    "Interrompu, le profil ne correspondait pas au programme souhaité, trop éloigné de l' Architecture",
  archicad_3dsMax: "Formation AUTOCAD, ARCHICAD, 3DS MAX.",
  devWeb: "Développeur Web, Openclassrooms",
  devWeb_val: "Diplôme de niveau 5 (bac +2)",
  experience: "Expérience",
  internship_1: "Stage de projection “IGC CONSTRUCT”",
  internship_2: "Stage préparation Diplôme “IGC CONSTRUCT” ",
  apprenticeship: "Apprentissage “IGC CONSTRUCT”",
  armanda: "Activité Non salariée Polyvalente : Société “Armanda” 75012 Paris",
  armanda_2: "Gérant : Société “Armanda” 75012 Paris",
  catalan: "Activité Non salariée Polyvalente Société “Catalan Building”",
  heres: "Société “Hères Construction”",
  heres_val: "Chef d'équipe, Chef de plusieurs équipes, Chef de Chantier",
  dev: "Développeur d'application - JavaScript React",
  dev_info: "Développement d'applications pour usage personnel",
  renovation: "Rénovation des maisons individuelles",
  characteristics: "Caractéristiques",
  characteristics_val:
    " Responsabilité, Engagement, Ponctualité, Sociabilité, Aptitude de travailler avec les clients pour trouver une solution individuelle. Aptitude de travailler en équipe, rapide et efficace. Capacité d'évaluer les situations, afin de surmonter les obstacles et prendre des mesures (solutions) qui correspondent. Capacité et envie d'apprendre vite et de façon efficace de nouveaux domaines.",
  software: "Logiciels",
  advenced: "avancé",
  medium: "moyen",
  basic: "base",
  dev_Technologies: "Technos de développement",
  install: "Installation et Entretien",
  install_val: "WINDOWS, Logiciels et Equipements de bureau.",
  languages: "Langues",
  rom_mold: "Roumaine/Moldave",
  french: "Français",
  native: "natif",
  russian: "Russe",
  english: "Anglais",
  writtenExpression: "expression écrite (le code et le commentaire en englais)",
  driver_sLicense: "Permis de conduire",
  driverCategory: "Catégorie B",
  download: "Télécharger",
  cardArch: [
    {
      id: "pr3-stade",
      title: "Centre d'entrainement, destiné aux forces de l'ordre.",
      description:
        "C'est un projet destinné aux forces de l'ordre, équipé d'un terrain de foot pour 2300 spectateurs,un terrain de volley, un terrain de basket, une piscine de 25m, un cort de tennis, plusiers salles de box et combat, une salle de fitness etc.",
      info: [
        "Stade: 2600 spectateurs.",
        "Espaces: Basket, Voley, Tennis, Box, Tir, Paintball, Fitness.",
        "Piscine: 25m, 6 couloirs.",
        "Repos: Sauna, Thérapie, Réstaurant.",
        "Parking: 360 voitures.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr3-stade"].cover,
      pictures: imagesArch["pr3-stade"].pictures,
    },
    {
      id: "pr-maison-perso",
      title: "Maison individuelle v-2024",
      description:
        "Maison pour une famille avec 3-4 enfants. Les photos sont des rendus (renders) realisées avec 3D'S MAX + V-ray.",
      info: [
        "Maison en pierre.",
        "Pour une famille de 5 - 6 personnes.",
        "RDC:séjour, sale à manger, cuisine, une chambre",
        "RDC: bloc sanitaire, buanderie et garage",
        "Étage: 3 chambres et bloc sanitaire. ",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr-maison-perso"].cover,
      pictures: imagesArch["pr-maison-perso"].pictures,
    },
    {
      id: "pr1-maison",
      title: "Maison individuelle P+S (Rez de chaussée + mansarde).",
      description:
        "Maison pour une famille avec 3-4 enfants. Les photos sont des rendus (renders) realisées avec 3D'S MAX + V-ray.",
      info: [
        "Maison en blocs de calcaires.",
        "Pour une famille de 5 - 6 personnes.",
        "Sous-sols: salle de sport et un dépôt.",
        "RDC: cuisine, sale à manger, séjour, bureau, bloc sanitaire.",
        "Étage: 4 chambres et bloc sanitaire. ",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr1-maison"].cover,
      pictures: imagesArch["pr1-maison"].pictures,
    },
    {
      id: "pr2-maison",
      title: "Maison, inspiré d'une conte de Fées.",
      description:
        "Cette maison avec des caractéristiques hors du commun reste assez connue. Le plus difficile est de systématiser l'espace pour la transformer dans un logement habitable.",
      info: [
        "Maison en blocs de calcaires.",
        "Pour une famille de 4 - 5 personnes.",
        "Projet connu,completement adaptaté au besoins du quotidien.",
        "RDC: Cuisine, salle à manger, séjour, WC.",
        "Étage: 3 chambres, SDB.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr2-maison"].cover,
      pictures: imagesArch["pr2-maison"].pictures,
    },
    {
      id: "pr3A-maison",
      title: "Maison individuelle v-2023",
      description: "Projet personnel",
      info: [
        "Maison en pierre ou en blocs creux.",
        "Pour une famille de 4 - 5 personnes.",
        "RDC: Cuisine, salle à manger, séjour, WC.,SDB",
        "Étage: 3 chambres, SDB.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr3A-maison"].cover,
      pictures: imagesArch["pr3A-maison"].pictures,
    },
    {
      id: "pr4-cinema",
      title: "Boogysh Cinéma",
      description:
        "Le projet Boogysh Cinéma, répresente la solution aux problèmes comme: la physique du son, calcule de visibilité en respectant les règles de l'art.",
      info: [
        "Salle de cinema, Longuer 24m, 5 secteurs.",
        "Capacité 528 places.",
        "Calcule de visibilité, assuré.",
        "Restaurants.",
        "Salles destinnées à l'administration.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr4-cinema"].cover,
      pictures: imagesArch["pr4-cinema"].pictures,
    },
    {
      id: "pr5-reconstruction",
      title: "La réconstruction d'un immeuble de 4 niveaux.",
      description:
        "La consolidation des fondations afin de rajouter un niveau et une mansarde.",
      info: [
        "Existent: Bâtiment en 4 niveaux, rez-de-chaussée + 3 étages.",
        "Rajout d'un étage supplémentaire et d'une mansarde.",
        "Calcule pour chaque type de fondation.",
        "Consolidation des fondations par tranche de 3m.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr5-reconstruction"].cover,
      pictures: imagesArch["pr5-reconstruction"].pictures,
    },
    {
      id: "pr6-urbanime",
      title: "Plan d'urbanisme",
      description:
        "Plan d'urbanisme en détails d'un cartier pour 5000 habitants",
      info: [
        "Quartier pour 5000 habitants.",
        "Une école maternelle.",
        "Éspaces aménagé: Pour les enfants 3-7 ans.",
        "Éspaces aménagé: Pour les enfants 7-12 ans.",
        "Éspaces verts.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr6-urbanime"].cover,
      pictures: imagesArch["pr6-urbanime"].pictures,
    },
    {
      id: "pr7-sistematisation-verticale",
      title: "Systématisation verticale",
      description:
        "Systématisation verticale d'un quartier avec l'artère routière adjacente",
      info: [
        "Identifier sur le plan  les courbes de niveau.",
        "D'après les courbes des niveaux, d'aménager un territoire avec des bâtiments et projeter une intersection dénivelée type trèfle allongé.",
        "Déterminer la cote '0' de chaque bâtiment.",
        "Montrer la section transversale de la  chossée. ",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesArch["pr7-sistematisation-verticale"].cover,
      pictures: imagesArch["pr7-sistematisation-verticale"].pictures,
    },
  ],
  cardBat: [
    {
      id: "pr1-terasse",
      title:
        "Réalisation d'une terasse en travertin et renovation de la piscine.",
      description: undefined,
      info: [
        "Réalisation d'une chappe de 6 à 12 cm.",
        "La pose du travertin ep. 2cm avec un  motif de 4 pieces. ",
        "La pose des margelles de la piscine ep. 5cm.",
        "Piscine - pose de la mosaïque 4.5cm x 4.5cm, colle epoxy. ",
        "Application des deux couches de protection sur la pierre.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["pr1-terasse"].cover,
      pictures: imagesBat["pr1-terasse"].pictures,
    },
    {
      id: "renovation_totale",
      title: "Rénovation totale d'un appartement",
      description: undefined,
      info: [
        "Démolition et évacuation des gravats.",
        "Réalisation l'ensemble des cloisons en placostil. ",
        "Installation des menuiseries.",
        "Electricité et plomberie",
        "Enduits et peinture",
        "Ragréage et chauffage au sol électrique",
        "Pause du carrelage dans la cuisine et les salles de bains.",
        "Pose collée du parquet massif dans les chambres.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["renovation_totale"].cover,
      pictures: imagesBat["renovation_totale"].pictures,
    },
    {
      id: "renovation_maison",
      title: "Rénovation d'une maison autour de Fontainebleau",
      description: undefined,
      info: [
        "Remise aux normes de l'électricité",
        "Enduits et peinture",
        "Ragréage sol",
        "Pose du parquet flottant au RDC, compatible pièces humides",
        "Projet et installation des meubles de cuisine IKEA",
        "Pose du parquet flottant dans les pièces à l'étage",
        "Pose du carrelage dans les toilettes st les salles de bains",
        "Changement VMC simple flux",
        "Modification de la plomberie",
        "Nouveau ballon eau chaude",
        "Coulage d'une dalle de 12cm d'éppaisseur sur la terrasse",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["renovation_maison"].cover,
      pictures: imagesBat["renovation_maison"].pictures,
    },
    {
      id: "consolidation_maison",
      title: "Consolidation des fondations",
      description: undefined,
      info: [
        "Creuser au long de la maison",
        "Creuser sous les fondations",
        "Feraillage l'ensemble",
        "Coulage du béton",
        "Application du produit d'étanchéité en deux couches",
        "Remblai avec de la terre",
        "Remblai avec de la terre végétale",
        "Reconstitution de la pelouse",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["consolidation_maison"].cover,
      pictures: imagesBat["consolidation_maison"].pictures,
    },
    {
      id: "ouvertures",
      title: "Création des ouvertures",
      description: undefined,
      info: [
        "Calcule des charges des murs, plancher et de la charpante.",
        "Calcul et le dimensionnement des profils métalliques.",
        "Réalisation des linteau en deux étapes.",
        "Réalisation des jambages en béton armé.",
        "Réalisation de l'ouverture et évacuation des gravats.",
        "Réalisation d'un appui où seuil en béton armé.",
        "La pose de la menuiserie conforme DTU.",
        "Dégrossi et l'enduisage des tableaux.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["ouvertures"].cover,
      pictures: imagesBat["ouvertures"].pictures,
    },
    {
      id: "extension",
      title: "Réalisation d'une extension. Gros œuvre. ",
      description: undefined,
      info: [
        "Réalisation des fondations en béton armé profondeur 1.2m.",
        "Plancher RDC avec des hourdis en polystyrène et béton armé. ",
        "Montage des murs en parpaings de 20cm.",
        "Façade bâti avec de la maçonnerie traditionnelle.",
        "Charpente avec les raccords appropriés",
        "Chainnage et poteaux en béton armé.",
        "Le toit et la lucarne sont couverts avec des tuiles plates.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["extension"].cover,
      pictures: imagesBat["extension"].pictures,
    },
    {
      id: "isolation-placo",
      title: "Isolation des murs exterieurs",
      description: undefined,
      info: [
        "Osature réalisée ave des rails et montants R48 et M48.",
        "Laine de verre GR32 avec l'épaisseur de 120mm.",
        "Membrane d'étanchéité.",
        "Placo BA13 normal/hydro/phonic/coupe feu.",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["isolation-placo"].cover,
      pictures: imagesBat["isolation-placo"].pictures,
    },
    {
      id: "assainissement",
      title: "Assainissement et drainage",
      description: undefined,
      info: [
        "Réalisation des tranchées  avec une pante 2cm au mètre.",
        "Encolage des tubes en PVC diametre 100mm pour chaque future évacuation.",
        "Raccord à l'extérieur de la maison dans un regard.",
        "Installation d'un regard 40x40 avec un tampon associé en béton. ",
        "Systeme de drainage avec 5 longueurs et une surface de 100 m.c. ",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesBat["assainissement"].cover,
      pictures: imagesBat["assainissement"].pictures,
    },
  ],
  cardDev: [
    {
      id: "pr12-fiche-eye",
      title: "Fiche-eye",
      urlProject: "https://fich-eye.vercel.app/",
      info: [
        "Creez un site pour les phographes",
        "Liker les images dans le local storage",
        "Creation d'un slider",
        "Trier les photos par popularité, date où titre",
        "Completer et valider le formulaire de contact",
        "Envoyer le message sur la base de donnés mongoDB",
      ],
      technos: ["html", "css", "js", "node", "mongoDB"],
      cover: imagesDev["pr12-fiche-eye"].cover,
      pictures: imagesDev["pr12-fiche-eye"].pictures,
    },
    {
      id: "pr11-moteur-recherche",
      title: "Créez un moteur de recherche",
      urlProject: "https://les-petits-plat.vercel.app/",
      info: [
        "Creez un moteur de recherche avec deux axes",
        "Creez des tags pour chaque valeur recherchée",
        "Chercher dans les ingredients, Appareils et Ustensiles",
        "Afficher l'intersection du resultat de recherche",
        "Afficher un message personalisé pour un resulatat nul",
      ],
      technos: ["html", "css", "js"],
      cover: imagesDev["pr11-moteur-recherche"].cover,
      pictures: imagesDev["pr11-moteur-recherche"].pictures,
    },
    {
      id: "pr10-social-media",
      title: "Créez une application web type reseau social",
      urlProject: "https://sm-boogysh.vercel.app/",
      info: [
        "Utilisation du redux et react-redux, BD MongoDB et S3-AWS.",
        "Voir les visiteurs de la page de l'utilisateur.",
        "Dark-mode et le boutton recherche des utilisateurs enregistrés.",
        "Backend pour gérer les requêtes GET, POST, PATCH, DELETE",
        "Enregistrer et supprimer les ficiers sur S3 et les URL sur MongoDB.",
        "Afficher l'ensamble de l'aplication en ligne avec Vercel.",
      ],
      technos: ["react", "tailwind", "redux", "node", "mongoDB", "aws"],
      cover: imagesDev["pr10-social-media"].cover,
      pictures: imagesDev["pr10-social-media"].pictures,
    },
    {
      id: "pr9-netflix-youtube",
      title: "Créez une application type netflix",
      urlProject: "https://boogysh-flix.vercel.app",
      info: [
        "Utilisation du redux et react-redux, BD MongoDB",
        "Backend pour gérer les requêtes GET, POST, PATCH, DELETE",
        "Intégrer l'api du themoviedb et youtube.",
        "Enregistrer les films dans les favorites",
        "Générer et voir le trailer du film de manière dynamique",
        "Afficher l'ensamble de l'aplication en ligne avec Vercel.",
      ],
      technos: [
        "react",
        "tailwind",
        "redux",
        "node",
        "mongoDB",
        "themoviedb",
        "youtube",
      ],
      cover: imagesDev["pr9-netflix-youtube"].cover,
      pictures: imagesDev["pr9-netflix-youtube"].pictures,
    },
    {
      id: "pr8-castle",
      title: "Créez une application web avec des éléments e-commerce",
      urlProject: "https://castle-boogysh.vercel.app/",
      info: [
        "Utilisation du redux et react-redux.",
        "Réalisation d'un backend pour gérer les requêtes GET, POST.",
        "Utilisation de la BD MongoDB et mongoose.",
        "Envoyer les messages et les commandes sur la base de données.",
        "Recherche des commandes avec l'email où le numéro de la commande.",
        "Afficher l'ensamble de l'aplication en ligne avec Vercel.",
      ],
      technos: ["react", "css", "redux", "node", "mongoDB"],
      cover: imagesDev["pr8-castle"].cover,
      pictures: imagesDev["pr8-castle"].pictures,
    },
    {
      id: "pr7-kasa",
      title: "Créez une application web de location immobilière avec React",
      urlProject: "https://boogysh.github.io/kasa/",
      info: [
        "Découpage en composants modulaires et réutilisables.",
        "Configurer la navigation entre les pages avec React Router.",
        "Utilisation des props entre les composants.",
        "Utilisation du state dans les composants quand c'est nécessaire.",
        "Gestion des événements.",
        "La page 404 est renvoyée pour chaque route inexistante, ou il y'a une faute dans l'URL.",
      ],
      technos: ["react", "css"],
      cover: imagesDev["pr7-kasa"].cover,
      pictures: imagesDev["pr7-kasa"].pictures,
    },
    {
      id: "pr6-api-piquante",
      title:
        "Construisez une API sécurisée pour une application d'avis gastronomiques",
      urlProject: "https://github.com/boogysh/piquante",
      info: [
        "Toutes les routes dispose d'une autorisation type: Bearer <token>.",
        "Le mot de passe de l'utilisateur est haché.",
        "L'adresse électronique dans la base de données MongoDB est unique  (mongoose-unique-validator).",
        "L'utilisateur est vérifié si il est autorisé de modifier ou supprimer une sauce.",
        "La remontée des erreurs issues de la base de donnée, par des messages d'erreurs personnalisés.",
      ],
      technos: ["node", "mongoDB"],
      cover: imagesDev["pr6-api-piquante"].cover,
      pictures: imagesDev["pr6-api-piquante"].pictures,
    },
    {
      id: "pr5-eCommerce",
      title: "Construisez un site e-commerce en JavaScript",
      urlProject: "https://github.com/boogysh/kanap",
      info: [
        "Gérer des événements JavaScript.",
        "Interagir avec un web service avec JavaScript.",
        "Valider des données issues de sources externes.",
        "Créer un plan de test pour une application.",
      ],
      technos: ["js"],
      cover: imagesDev["pr5-eCommerce"].cover,
      pictures: imagesDev["pr5-eCommerce"].pictures,
    },
    {
      id: "pr4-SEO",
      title: "Optimisez un site web existant:",
      urlProject: "https://boogysh.github.io/La-panthere/",
      urlExistent: "https://boogysh.github.io/la-panthere_initial/",
      info: [
        "Utiliser un domaine personalisé.",
        "Optimiser la taille et la vitesse d'un site web.",
        "Réaliser une recherche des bonnes pratiques en développement web.",
        "Écrire un code HTML et CSS maintenable.",
        "Assurer l'accessibilité d'un site web.",
        "Optimiser le référencement d'un site web.",
      ],
      technos: ["html", "css", "js"],
      cover: imagesDev["pr4-SEO"].cover,
      pictures: imagesDev["pr4-SEO"].pictures,
    },
    {
      id: "pr3-ohmyfood",
      title: "Dynamisez une page web avec des animations CSS",
      urlProject: "https://boogysh.github.io/OCR_PR3/",
      info: [
        "Utiliser un système de gestion de versions pour le suivi du projet et son hébergement.",
        "Mettre en place son environnement frontend.",
        "Assurer la cohérence graphique d'un site web.",
        "Mettre en place une structure de navigation pour un site web.",
        "Mettre en œuvre des effets CSS graphiques avancés.",
      ],
      technos: ["html", "sass"],
      cover: imagesDev["pr3-ohmyfood"].cover,
      pictures: imagesDev["pr3-ohmyfood"].pictures,
    },
    {
      id: "pr2-booki",
      title: "Transformez une maquette en site web avec html et css",
      urlProject: "https://boogysh.github.io/booki/",
      info: [
        "Découpage de la maquete.",
        "Réalisation de la page hébergements.",
        "Réalisation de la page activités.",
        "Utiliser des balises sémantiques.",
        "Réalisation de la partie responsive.",
        "Validation du code auprès du W3C.",
      ],
      technos: ["html", "css"],
      cover: imagesDev["pr2-booki"].cover,
      pictures: imagesDev["pr2-booki"].pictures,
    },
  ],
  cardServices: [
    {
      id: "second_oeuvres",
      title: "Seconds œuvres",
      description: undefined,
      info: [
        "Réalisation des chapes et ragréages",
        "Isolation thermique et phonique",
        "Pose des menuiserie intérieures",
        "Cloisons en Placostil et carreau de plâtre",
        "Enduits et peinture",
        "Parquet collé et flottant",
        "Etanchéité, Carrelage et faïence murale",
        "Raccord de l'électricité et de la plomberie",
        "Assemblage et installation des meubles",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesServices["second_oeuvres"].cover,
      pictures: imagesServices["second_oeuvres"].pictures,
    },
    {
      id: "gros_oeuvres",
      title: "Gros œuvres",
      description: undefined,
      info: [
        "Création d'ouvertures",
        "La pose des menuiseries extérieures",
        "Réalisation petit terrassement avec difficulté d'accès pour les engins",
        "Réalisation des dalles ou terrasses de 12cm d'épaisseur.",
        "Monter des murs",
        "Raccord de l'ssainissement dans le cadre de la rénovation",
        "Consolidation des fondations",
      ],
      technos: ["react", "tailwind", "node", "mongoDB"],
      cover: imagesServices["gros_oeuvres"].cover,
      pictures: imagesServices["gros_oeuvres"].pictures,
    },
  ],
  cardDevis: [
    {
      id: "opening",
      mainTitle: `Création d'une baie vitrée L240xH220 ( mur épaisseur 60cm )`,
      keyWord: [
        "linteau",
        "jambages",
        "l'ouverture",
        "seuil",
        "tableau",
        "baie vitrée",
      ],
      content: [
        {
          title: `Etayage et mise en sécurité.`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 60,
          time: 4,
        },
        {
          title: `Réalisation d'une saigné d'une coté du mur et préparation des assises.`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 10,
          time: 6,
        },
        {
          title:
            "Réalisation d'un linteau en béton armé avec poutrelles en béton ou fourniture et pose d'un fer dimmensionné avec une couche d'antirouille",
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 241.04,
          time: 6,
        },
        {
          title: "Maçonner l'espace crée au dessus du linteau",
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 8,
          time: 4,
        },
        {
          title:
            "Réalisation d'une saigné de l'autre coté du mur et préparation des assises.",
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 10.0,
          time: 6,
        },
        {
          title:
            "Réalisation d'un linteau en béton armé avec poutrelles en béton ou fourniture et pose d'un fer dimmensionné avec une couche d'antirouille",
          type: "work",
          qty: "1",
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 241.04,
          time: 6,
        },
        {
          title: "Maçonner l'éspace crée au dessus du linteau",
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 8,
          time: 4,
        },
        {
          title: "Réalisation de l'ouverture",
          type: "work",
          qty: 2.46,
          qtyUnit: "m3",
          itemPrice: 4, //!!!!!!!!!
          itemPriceUnit: "h/m3",
          supply: 10.0,
          time: 1.11,
        },
        {
          title: "Evacuation des gravas en decharge droit inclus",
          type: "work",
          qty: 3.51,
          qtyUnit: "m3",
          itemPrice: 4, //!!!!!!!!!
          itemPriceUnit: "h/m3",
          supply: 170.58,
          // time: 14.04,
        },
        {
          title:
            "Réalisation des jambages armés et réalisation du tableau intérieur avec ébrasement",
          type: "work",
          qty: 2,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 110.0,
          time: 16,
        },
        {
          title: "Réalisation d'un seuil en mortier de ciment moulé",
          type: "work",
          qty: 2.4,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 42,
          time: 4.8,
        },
        {
          title: "Réalisation du tableau éxterieur",
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 52.35,
          time: 8,
        },
        {
          title: "Réalisation des bandeaux. Dégrossi et enduit de finition.",
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 82.5,
          time: 8,
        },
        {
          // work supply=value
          title: `Nettoyage de fin de chantier`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: "",
          itemPriceUnit: "",
          supply: 0.5,
          time: 4,
        },
      ],
    },

    // ---------------POSE CARRELAGE-------------
    {
      id: "layingTiles",
      mainTitle: `Pose du carrelage 60x60  (pose pieds-droits)`,
      content: [
        {
          // buy  no supply  &  no time
          title: `Fourniture du carrelage. 60mc +10%`,
          type: "buy",
          qty: 66,
          qtyUnit: "m2",
          itemPrice: 25,
          itemPriceUnit: "€/m2",
        },
        {
          // buy  no supply  &  no time
          title: `Colle flex (double encollage)`,
          type: "buy",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 4.5,
          itemPriceUnit: "€/m2",
        },
        {
          // buy  no supply  &  no time
          title: `Joints (matériaux)`,
          type: "buy",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 3,
          itemPriceUnit: "€/m2",
        },
        {
          // buy  no supply  &  no time
          title: `Plinthes assorties ou profilés de finition 42ml + 10%`,
          type: "buy",
          qty: 46.2,
          qtyUnit: "ml",
          itemPrice: 11.9,
          itemPriceUnit: "€/ml",
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture du produit d'accrochage)`,
          type: "buy",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 1.32,
          itemPriceUnit: "€/m2",
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture du ragréage P3`,
          type: "buy",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 8.9,
          itemPriceUnit: "€/m2",
        },
        {
          // work supply=value
          title: `Préparation du support (nettoyage, produit d'accrochage)`,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.15,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 4,
        },

        {
          // work supply=value
          title: `Réalisation du ragréage P3`,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.5,
          itemPriceUnit: "h/m2",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose carrelage 60×60 (pose pieds-droits, double encollage)`,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 1,
          itemPriceUnit: "h/m2",
          supply: 65.72,
          // time: 0,
        },
        {
          // work supply=value
          title: `Découpes (les bordures, obstacles, angles)`,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.1,
          itemPriceUnit: "h/m2",
          supply: 35.5,
          // time: 0,
        },
        {
          // work supply=value
          title: `Réalisation des joints de finition & nettoyage final`,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.5,
          itemPriceUnit: "h/m2",
          supply: 25.82,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose des plinthes et joints associés 42ml`,
          type: "work",
          qty: 42,
          qtyUnit: "ml",
          itemPrice: 0.4,
          itemPriceUnit: "h/ml",
          supply: 8.2,
          // time: 0,
        },

        {
          // work supply=value
          title: `Pose des seuils, decoupes des portes & mise des butées `,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.1,
          itemPriceUnit: "h/m2",
          supply: 24,
          // time: 0,
        },
        {
          // work supply=value
          title: `Nettoyage de fin de chantier`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          // itemPrice: 0,
          itemPriceUnit: "h/u",
          supply: "0",
          time: 4,
        },
      ],
    },
    // -------------POSE PARQUET FLOTTANT -----------
    {
      id: "layingParquet",
      mainTitle: `Pose du parquet flottant`,
      content: [
        {
          // buy  no supply  &  no time
          title: `Fourniture du parquet contrecollé, stratifié où vinyl - compatible avec les pièces humides`,
          type: "buy",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 35,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture des plinthes en medium`,
          type: "buy",
          qty: 46.2,
          qtyUnit: "m2",
          itemPrice: 1.5,
          itemPriceUnit: "€/ml",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Sous-couche isolante / pare-vapeur`,
          type: "buy",
          qty: 46.2,
          qtyUnit: "m2",
          itemPrice: 4,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Seuils des portes`,
          type: "buy",
          qty: 4,
          qtyUnit: "u",
          itemPrice: 18,
          itemPriceUnit: "€/u",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture du produit d'accrochage)`,
          type: "buy",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 1.32,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture du ragréage P3`,
          type: "buy",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 8.9,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // work supply=value
          title: `Préparation du support (nettoyage, produit d'accrochage)`,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.15,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 4,
        },

        {
          // work supply=value
          title: `Réalisation du ragréage P3`,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.5,
          itemPriceUnit: "h/m2",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose sous-couche isolante / pare-vapeur`,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.15,
          itemPriceUnit: "h/m2",
          supply: 3.5,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose parquet flottant clipsé`,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.6,
          itemPriceUnit: "h/m2",
          supply: 12,
          // time: 0,
        },
        {
          // work supply=value
          title: `Découpes finitions  `,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.1,
          itemPriceUnit: "h/m2",
          supply: 24,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose des seuils, decoupes des portes & mise des butées `,
          type: "work",
          qty: 60,
          qtyUnit: "m2",
          itemPrice: 0.1,
          itemPriceUnit: "h/m2",
          supply: 24,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose des plinthes avec finition acrylique`,
          type: "work",
          qty: 42,
          qtyUnit: "m2",
          itemPrice: 0.4,
          itemPriceUnit: "h/ml",
          supply: 18,
          // time: 0,
        },
        {
          // work supply=value
          title: `Nettoyage de fin de chantier`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 0,
          itemPriceUnit: "",
          supply: 0,
          time: 4,
        },
      ],
    },
    // -------------POSE PORTE PLEINE -----------
    {
      id: "installDoor",
      mainTitle: `Pose d'un bloc porte intérieur`,
      content: [
        {
          // buy  no supply  &  no time
          title: `Fourniture d'un bloc-porte pleine`,
          type: "buy",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 195,
          itemPriceUnit: "€/u",
          // supply
          time: 0,
        },
        {
          // work supply=value
          title: `Pose d'un bloc porte intérieur coeur plein`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 4,
          itemPriceUnit: "h/u",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Raccords de platre associés, hors enduits et peinture`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 4,
          itemPriceUnit: "h/u",
          supply: 16,
          // time: 0,
        },
      ],
    },
    // -------------CREATION CLOISON PLACOSTIL -----------
    {
      id: "wallPlacostil",
      mainTitle: `Devis de creation d'une cloison placostil`,
      content: [
        {
          // buy  no supply  &  no time
          title: `Fourniture des rails R48`,
          type: "buy",
          qty: 5,
          qtyUnit: "u",
          itemPrice: 2.79,
          itemPriceUnit: "€/u",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture des montants M48`,
          type: "buy",
          qty: 14,
          qtyUnit: "u",
          itemPrice: 2.79,
          itemPriceUnit: "€/u",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture de bande résiliante en mousse autocollante 50mm, Ep 3mm`,
          type: "buy",
          qty: 10,
          qtyUnit: "u",
          itemPrice: 0.33,
          itemPriceUnit: "€/ml",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture de la laine de verre 45mm`,
          type: "buy",
          qty: 11,
          qtyUnit: "u",
          itemPrice: 3.29,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture des plaques BA13 2.5m x 1.2m KNAUF`,
          type: "buy",
          qty: 21,
          qtyUnit: "mp",
          itemPrice: 3.6,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture des plinthes`,
          type: "buy",
          qty: 9,
          qtyUnit: "ml",
          itemPrice: 1.49,
          itemPriceUnit: "€/ml",
          // supply
          time: 0,
        },
        {
          // work supply=value
          title: `Création structure placostil avec bande résiliante`,
          type: "work",
          qty: 10,
          qtyUnit: "m2",
          itemPrice: 0.35,
          itemPriceUnit: "h/m2",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose laine de verre 45mm`,
          type: "work",
          qty: 10,
          qtyUnit: "m2",
          itemPrice: 0.15,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Vissage des plaque BA13`,
          type: "work",
          qty: 20,
          qtyUnit: "m2",
          itemPrice: 0.35,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Collage des bandes avec 2 couches de finition`,
          type: "work",
          qty: 20,
          qtyUnit: "m2",
          itemPrice: 0.3,
          itemPriceUnit: "h/m2",
          supply: 14,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose des plinthes avec finition acrylique`,
          type: "work",
          qty: 8,
          qtyUnit: "ml",
          itemPrice: 0.4,
          itemPriceUnit: "h/ml",
          supply: 14,
          // time: 0,
        },
      ],
    },
    // -------------Devis enduit et peinture SAM 15mc au sol avec ouverture de 3m sur le salon -----------
    {
      id: "EnduitPeinture",
      mainTitle: `Devis de réalisation des enduit et peinture salle à manger`,
      content: [
        {
          // buy  no supply  &  no time
          title: `Fourniture enduit Prestonett F`,
          type: "buy",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 32.9,
          itemPriceUnit: "€/l",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture impression Zolpan`,
          type: "buy",
          qty: 5,
          qtyUnit: "l",
          itemPrice: 15.65,
          itemPriceUnit: "€/l",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture peinture velours murs`,
          type: "buy",
          qty: 5,
          qtyUnit: "u",
          itemPrice: 15.65,
          itemPriceUnit: "€/l",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture peinture mat plafond`,
          type: "buy",
          qty: 3,
          qtyUnit: "l",
          itemPrice: 15.65,
          itemPriceUnit: "€/l",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture protection polyane fin`,
          type: "buy",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 9.99,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture diverse rouleau,scotch, papier abrasif, acrylique`,
          type: "buy",
          qty: 43,
          qtyUnit: "u",
          itemPrice: 1.6,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // work supply=value
          title: `Degraissage des murs`,
          type: "work",
          qty: 40,
          qtyUnit: "m2",
          itemPrice: 0.08,
          itemPriceUnit: "h/m2",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Protection / masquage`,
          type: "work",
          qty: 43,
          qtyUnit: "m2",
          itemPrice: 0.08,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Arachage du papier peint`,
          type: "work",
          qty: 0,
          qtyUnit: "m2",
          itemPrice: 0.17,
          itemPriceUnit: "h/m2",
          supply: "0",
          // time: 0,
        },
        {
          // work supply=value
          title: `Traitement des fissures (0.1-0.2 h/ml), collage des bandes`,
          type: "work",
          qty: 10,
          qtyUnit: "ml",
          itemPrice: 0.15,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Application impression haute de gamme`,
          type: "work",
          qty: 43,
          qtyUnit: "m2",
          itemPrice: 0.1,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Application d'enduits 1-ère couche`,
          type: "work",
          qty: 43,
          qtyUnit: "m2",
          itemPrice: 0.2,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Gratage des imperfections après la 1-ère couche`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 1,
          itemPriceUnit: "h/u",
          supply: "0",
          // time: 0,
        },
        {
          // work supply=value
          title: `Application d'enduits 2-ème couche, passe croisée`,
          type: "work",
          qty: 43,
          qtyUnit: "m2",
          itemPrice: 0.18,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Gratage des imperfections après la 2-ème couche`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 1,
          itemPriceUnit: "h/u",
          supply: "0",
          // time: 0,
        },
        {
          // work supply=value
          title: `Application d'enduits 3-ème couche, finition parfaite`,
          type: "work",
          qty: 43,
          qtyUnit: "m2",
          itemPrice: 0.16,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },

        {
          // work supply=value
          title: `Ponçage et dépoussiérage`,
          type: "work",
          qty: 43,
          qtyUnit: "m2",
          itemPrice: 0.2,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Application impression haute de gamme`,
          type: "work",
          qty: 43,
          qtyUnit: "m2",
          itemPrice: 0.11,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Application peinture Zolpan haute de gamme au rouleau 1-ère couche`,
          type: "work",
          qty: 43,
          qtyUnit: "m2",
          itemPrice: 0.12,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Application peinture Zolpan haute de gamme au rouleau 2-ème couche`,
          type: "work",
          qty: 43,
          qtyUnit: "m2",
          itemPrice: 0.12,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Nettoyage / finitions`,
          type: "work",
          qty: 43,
          qtyUnit: "m2",
          itemPrice: 0.08,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
      ],
    },
    // -------------Devis Remplacement menuiserie exterieure -----------
    {
      id: "windowOrDorReplace",
      mainTitle: `Devis de remplacement d'une fenetre exterieure bois, pvc, alu 1.5m x1.4m`,
      content: [
        {
          // buy  no supply  &  no time
          title: `Fourniture de la menuiserie par le client`,
          type: "buy",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 0,
          itemPriceUnit: "€/u",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture des joint précomprimés`,
          type: "buy",
          qty: 5.8,
          qtyUnit: "ml",
          itemPrice: 1.2,
          itemPriceUnit: "€/ml",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture des pates de scellement`,
          type: "buy",
          qty: 8,
          qtyUnit: "u",
          itemPrice: 1.5,
          itemPriceUnit: "€/u",
          // supply
          time: 0,
        },
        {
          // work supply=value
          title: `Protection des lieux`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 1,
          itemPriceUnit: "h/u",
          supply: 12,
          // time: 0,
        },

        {
          // work supply=value
          title: `Decoupe d'une bande de 30cm du placo autour de la menuiserie, ou piochage du platre`,
          type: "work",
          qty: 5.8,
          qtyUnit: "ml",
          itemPrice: 0.35,
          itemPriceUnit: "h/ml",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Dépose de l'ancienne menuiserie`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 2,
          itemPriceUnit: "h/u",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Fixation`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 4,
          itemPriceUnit: "h/u",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose joints précomprimés`,
          type: "work",
          qty: 5.8,
          qtyUnit: "ml",
          itemPrice: 0.1,
          itemPriceUnit: "h/u",
          supply: "0",
          // time: 0,
        },
        {
          // work supply=value
          title: `Application mastic de finition coté exterieur`,
          type: "work",
          qty: 5.8,
          qtyUnit: "ml",
          itemPrice: 0.15,
          itemPriceUnit: "h/u",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Raccord du plâtre associé, ou placo avec les bandes collées, hors peinture`,
          type: "work",
          qty: 5.8,
          qtyUnit: "ml",
          itemPrice: 0.7,
          itemPriceUnit: "h/u",
          supply: 12,
          // time: 0,
        },
        {
          // work supply=value
          title: `Replie de chantier`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 1,
          itemPriceUnit: "h/u",
          supply: "0",
          // time: 0,
        },
      ],
    },
    // -------------Devis Remplacement porte exterieure -----------
    {
      id: "doorReplace",
      mainTitle: `Devis de remplacement d'une porte exterieure bois, pvc, alu 2.1m x 0.9m`,
      content: [
        {
          // buy  no supply  &  no time
          title: `Fourniture de la menuiserie par le client`,
          type: "buy",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 0,
          itemPriceUnit: "€/u",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture des joint précomprimés`,
          type: "buy",
          qty: 6.2,
          qtyUnit: "ml",
          itemPrice: 1.2,
          itemPriceUnit: "€/ml",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture des pates de scellement`,
          type: "buy",
          qty: 8,
          qtyUnit: "u",
          itemPrice: 1.5,
          itemPriceUnit: "€/u",
          // supply
          time: 0,
        },
        {
          // work supply=value
          title: `Protection des lieux`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 1,
          itemPriceUnit: "h/u",
          supply: 12,
          // time: 0,
        },

        {
          // work supply=value
          title: `Decoupe d'une bande de 30cm du placo autour de la menuiserie, ou piochage du platre`,
          type: "work",
          qty: 6.2,
          qtyUnit: "ml",
          itemPrice: 0.35,
          itemPriceUnit: "h/ml",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Dépose de l'ancienne menuiserie`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 2,
          itemPriceUnit: "h/u",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Fixation`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 4,
          itemPriceUnit: "h/u",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose joints précomprimés`,
          type: "work",
          qty: 6.2,
          qtyUnit: "ml",
          itemPrice: 0.1,
          itemPriceUnit: "h/u",
          supply: "0",
          // time: 0,
        },
        {
          // work supply=value
          title: `Application mastic de finition coté exterieur`,
          type: "work",
          qty: 6.2,
          qtyUnit: "ml",
          itemPrice: 0.15,
          itemPriceUnit: "h/u",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Raccord du plâtre associé, ou placo avec les bandes collées, hors peinture`,
          type: "work",
          qty: 6.2,
          qtyUnit: "ml",
          itemPrice: 0.7,
          itemPriceUnit: "h/u",
          supply: 12,
          // time: 0,
        },
        {
          // work supply=value
          title: `Replie de chantier`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 1,
          itemPriceUnit: "h/u",
          supply: "0",
          // time: 0,
        },
      ],
    },
    // -------------Devis Remplacement porte exterieure -----------
    {
      id: "SDB",
      mainTitle: `Devis rénovation salle de bain 7m2 au sol  murs-27m2, faiilance 50% de murs soit 13.5m2, le autres 13.5m2  enduits 3 couches et peinture`,
      content: [
        {
          // work supply=value
          title: `Installation du receveur de douche ou la baignoire, la paroi de douche, la robinetrie et les meubles seront installées par le plombier`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 0,
          itemPriceUnit: "u",
          supply: "0",
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture du carrelage par le client`,
          type: "buy",
          qty: 7.7,
          qtyUnit: "m2",
          itemPrice: 30,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Plinthes assorties ou profilés de finition 5.4ml + 10%`,
          type: "buy",
          qty: 5.4,
          qtyUnit: "ml",
          itemPrice: 11.9,
          itemPriceUnit: "€/ml",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture de la faïence murale par le client`,
          type: "buy",
          qty: 14.85,
          qtyUnit: "m2",
          itemPrice: 30,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Colle flex (double encollage)`,
          type: "buy",
          qty: 20.5,
          qtyUnit: "m2",
          itemPrice: 4.5,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Joints (matériaux)`,
          type: "buy",
          qty: 20.5,
          qtyUnit: "m2",
          itemPrice: 3,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture Résine d'étanchéité sous carrelage 5kg Mapei `,
          type: "buy",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 50.9,
          itemPriceUnit: "€/u",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture Bande d'armature pour étanchéité 10ml - Mapei `,
          type: "buy",
          qty: 2,
          qtyUnit: "u",
          itemPrice: 29.9,
          itemPriceUnit: "€/u",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture raagreage P3`,
          type: "buy",
          qty: 7.7,
          qtyUnit: "m2",
          itemPrice: 8.9,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },
        {
          // buy  no supply  &  no time
          title: `Fourniture du produit d'accrochage`,
          type: "buy",
          qty: 7,
          qtyUnit: "m2",
          itemPrice: 1.32,
          itemPriceUnit: "€/m2",
          // supply
          time: 0,
        },

        {
          // work supply=value
          title: `Protection des lieux`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 1,
          itemPriceUnit: "h/u",
          supply: 12,
          // time: 0,
        },
        {
          // work supply=value
          title: `Depose des meubles et sanitaires et évacuation`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 3,
          itemPriceUnit: "h/u",
          supply: "0",
          // time: 0,
        },
        {
          // work supply=value
          title: `Depose du 7m2 de carrelage`,
          type: "work",
          qty: 7,
          qtyUnit: "m2",
          itemPrice: 0.55,
          itemPriceUnit: "h/m2",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Depose du 13.5m2 de faïence`,
          type: "work",
          qty: 13.5,
          qtyUnit: "m2",
          itemPrice: 0.55,
          itemPriceUnit: "h/m2",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Préparation du support (nettoyage, produit d'accrochage)`,
          type: "work",
          qty: 7,
          qtyUnit: "m2",
          itemPrice: 0.15,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 4,
        },
        {
          // work supply=value
          title: `Réalisation du ragréage P3`,
          type: "work",
          qty: 7,
          qtyUnit: "m2",
          itemPrice: 0.5,
          itemPriceUnit: "h/m2",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Encollage bandes d'armature pour étanchéité`,
          type: "work",
          qty: 16,
          qtyUnit: "ml",
          itemPrice: 0.2,
          itemPriceUnit: "h/ml",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Application produit d'étanchéité 2 couches`,
          type: "work",
          qty: 13.5,
          qtyUnit: "m2",
          itemPrice: 0.4,
          itemPriceUnit: "h/m2",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose carrelage et faïence (pose pieds-droits, double encollage)`,
          type: "work",
          qty: 20.5,
          qtyUnit: "m2",
          itemPrice: 1,
          itemPriceUnit: "h/m2",
          supply: 18,
          // time: 0,
        },
        {
          // work supply=value
          title: `Découpes (les bordures, obstacles, angles)`,
          type: "work",
          qty: 20.5,
          qtyUnit: "m2",
          itemPrice: 0.1,
          itemPriceUnit: "h/m2",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Pose des plinthes et joints associés`,
          type: "work",
          qty: 5.4,
          qtyUnit: "ml",
          itemPrice: 0.4,
          itemPriceUnit: "h/ml",
          supply: 4,
          // time: 0,
        },
        {
          // work supply=value
          title: `Réalisation des joints de finition & nettoyage final`,
          type: "work",
          qty: 20.5,
          qtyUnit: "m2",
          itemPrice: 0.5,
          itemPriceUnit: "h/m2",
          supply: 8,
          // time: 0,
        },
        {
          // work supply=value
          title: `Application d'impression, enduits 3 couches, ponçage, impression et 2 couches de peinture + 2.5m2 la porte + 7m2 le plafond`,
          type: "work",
          qty: 23.0,
          qtyUnit: "m2",
          itemPrice: 1.5,
          itemPriceUnit: "h/m2",
          supply: 217.69,
          // time: 0,
        },
        {
          // work supply=value
          title: `Nettoyage de fin de chantier`,
          type: "work",
          qty: 1,
          qtyUnit: "u",
          itemPrice: 0,
          itemPriceUnit: "",
          supply: 0,
          time: 1.5,
        },
      ],
    },
  ],
};
